<bn-care-plan-item-card>
  <div carePlanCardMain [class.bn-action-card--closed]="isClosed()">
    <h4 class="bn-action-card__title m-0">{{ action().title }}</h4>
    @if (action().description) {
      <p class="bn-action-card__description m-0">{{ action().description }}</p>
    }
    <p class="bn-action-card__meta m-0">
      {{ ownerLabel() }} · {{ typeLabel() }} ·
      @if (isOverdue()) {
        <span class="bn-action-card__overdue"
          >Overdue {{ dueDateLabel() }}</span
        >
      } @else if (completedDateLabel(); as completed) {
        Completed {{ completed }}
      } @else if (isClosed()) {
        {{ statusLabel() }}
      } @else {
        Due {{ dueDateLabel() }}
      }
    </p>
    @if (!action().caseId || caseDomainLabel() || action().clientPromise) {
      <div class="bn-action-card__chips">
        @if (!action().caseId) {
          <span class="bn-action-card__domain">No case</span>
        }
        @if (caseDomainLabel(); as domainLabel) {
          <span class="bn-action-card__domain">{{ domainLabel }}</span>
        }
        @if (action().clientPromise) {
          <span class="bn-action-card__promise">Client promise</span>
        }
      </div>
    }
  </div>

  <div
    carePlanCardActions
    class="bn-action-card__actions"
    [class.bn-action-card__actions--client-view]="showGoToCase()"
  >
    @if (!readonly()) {
      <bn-care-plan-status-select
        [options]="statusOptions()"
        ariaLabel="Action status"
        [placeholder]="statusLabel()"
        [value]="displayedStatusCode()"
        [loading]="store().isSaving(action().id)"
        [disabled]="
          store().isSaving(action().id) || statusOptions().length === 0
        "
        (valueChange)="onStatusChange($event)"
      />
    } @else {
      <span class="bn-action-card__status">{{ statusLabel() }}</span>
    }
    @if (showGoToCase() || !readonly()) {
      <div class="bn-action-card__links">
        @if (showGoToCase()) {
          <button
            type="button"
            class="bn-action-card__edit"
            (click)="openCase()"
          >
            Go to case
          </button>
        }
        @if (!readonly()) {
          <button
            type="button"
            class="bn-action-card__edit"
            (click)="openEdit()"
          >
            View/Edit
          </button>
        }
      </div>
    }
  </div>
</bn-care-plan-item-card>
